import { ArnErc721NftService } from './erc721/ArnErc721NftService';
import { ArnNftContext } from './ArnNftContext';
import { ArnArianeeNftService } from './arianee/ArnArianeeNftService';
import { ArnErc721ANftService } from './erc721a/ArnErc721ANftService';
import { ArnNftService } from './ArnNftService';

export abstract class ArnAbstractNftService implements ArnNftService {
  protected _context: ArnNftContext | undefined;

  inContext(context: ArnNftContext | undefined): this {
    if (context instanceof ArnNftContext) {
      this._context = context;
    }
    return this;
  }

  get context(): ArnNftContext | undefined {
    return this._context;
  }

  abstract get arianee(): ArnArianeeNftService;

  abstract get erc721(): ArnErc721NftService;

  abstract get erc721a(): ArnErc721ANftService;
}
